export interface TimeAttendance {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy?: unknown;
  ownerList?: unknown;
  orgId: number;
  year: number;
  month: number;
  startMonth: number;
  endMonth: number;
  employeeId: number;
  employeeCode: string;
  fullName: string;
  workLevelId?: number;
  totalWorkDays: number;
  standardWorkDays: number;
  day1: number;
  day2: number;
  day3: number;
  day4: number;
  day5: number;
  day6: number;
  day7: number;
  day8: number;
  day9: number;
  day10: number;
  day11: number;
  day12: number;
  day13: number;
  day14: number;
  day15: number;
  day16: number;
  day17: number;
  day18: number;
  day19: number;
  day20: number;
  day21: number;
  day22: number;
  day23: number;
  day24: number;
  day25: number;
  day26: number;
  day27: number;
  day28: number;
  day29: number;
  day30: number;
  day31: number;
  otHours: number;
  otWeekDays: number;
  otWeekends: number;
  otHolidays: number;
  totalLeaves: number;
  paidLeaves: number;
  totalHolidays: number;
  unpaidLeaves: number;
  isSummary: boolean;
  employee: Employee;
  lateIn: number;
  earlyOut: number;
  lateInHours: number;
  earlyOutHours: number;
}

interface Employee {
  id: number;
  code: string;
  email: string;
  title: string;
  userId: number;
  fullName: string;
  titleCode: string;
  workLevel: WorkLevel;
  department: Department;
  workLevelId: number;
  departmentId: number;
  employmentType: string;
}

interface Department {
  id: number;
  code: string;
  name: string;
  paths: number[];
}

interface WorkLevel {
  id: number;
  code: string;
  name: string;
  nativeName: string;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface TimeAttendanceImportRequest {
  year: number;
  month: number;
  startMonth: number;
  endMonth: number;
  templateId?: string;
  templatePeriod?: number;
  cycleId?: string;
  items: TimeAttendanceImportItem[];
  employeeCodes: string[];
  fileName?: string;
}

interface TimeAttendanceImportItem {
  employeeCode: string;
  totalWorkDays: number;
  day1: number;
  day2: number;
  day3: number;
  day4: number;
  day5: number;
  day6: number;
  day7: number;
  day8: number;
  day9: number;
  day10: number;
  day11: number;
  day12: number;
  day13: number;
  day14: number;
  day15: number;
  day16: number;
  day17: number;
  day18: number;
  day19: number;
  day20: number;
  day21: number;
  day22: number;
  day23: number;
  day24: number;
  day25: number;
  day26: number;
  day27: number;
  day28: number;
  day29: number;
  day30: number;
  day31: number;
}

export interface TimeAttendanceImportOverTimeRequest {
  year: number;
  month: number;
  items: TimeAttendanceImportOverTimeItem[];
  employeeCodes: string[];
  fileName?: string;
  templateId?: string;
  templatePeriod?: number;
  cycleId?: string;
}

interface TimeAttendanceImportOverTimeItem {
  employeeCode: string;
  date: string;
  fromTime: string;
  toTime: string;
  description: string;
  otHours: number;
  otRateCode: string;
}

export interface TimeAttendanceImportLeaveRequest {
  year: number;
  month: number;
  items: TimeAttendanceImportLeaveItem[];
  employeeCodes: string[];
  fileName?: string;
  templateId?: string;
  templatePeriod?: number;
  cycleId?: string;
}

interface TimeAttendanceImportLeaveItem {
  employeeCode: string;
  date: string;
  leaveTypeCode: string;
  duration: number;
  comment: string;
}

export interface TimeAttendanceListRequest {
  page?: number | null;
  limit?: number | null;
  year?: number | null;
  month?: number | null;
  status?: number | null;
  ids?: number[] | null;
  keyword?: string | null;
  templateId?: string | null;
  templatePeriod?: string | null;
  cycleId?: string | null;
  departmentId?: number | null;
  isCheckStandard?: boolean | null;
  otHours?: number | null;
  totalWorkDays?: number | null;
  isHasData?: boolean | null;
  checkRule?: string[] | null;
}

export interface TimeAttendanceListResponse extends RestAPIMetaResponse {
  items: Array<TimeAttendance>;
}

export interface TimeAttendanceSummary {
  orgId: number;
  month: number;
  year: number;
  totalOTHours: number;
  totalOTHolidays: number;
  totalOTWeekDays: number;
  totalOTWeekends: number;
  totalWorkDays: number;
  paidTotalLeaves: number;
  unpaidTotalLeaves: number;
  totalEmployee: number;
  totalHolidays: number;
}

export interface TimeAttendanceSummaryRequest {
  month?: number;
  year?: number;
  templateId?: string | null;
  templatePeriod?: string | null;
  cycleId?: string | null;
}

export type TimeAttendanceSummaryResponse = TimeAttendanceSummary[];

export enum TimeAttendanceCheckRule {
  STANDARD_WORKDAY = "STANDARD_WORKDAY",
  OT_HOURS = "OT_HOURS",
  NONE_DATA = "NONE_DATA",
}
